module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "owl-carousel"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      staticClass: "item"
    }, [_c('pre', [_vm._v(_vm._s(item))])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b7cbcc5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/sliders/default.vue
// module id = 266
// module chunks = 35